import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchPeekViewData, PeekViewRecordType } from "./api"

export function usePeekViewData(recordId: string, recordType: PeekViewRecordType, enabled: boolean = true) {
  const getContext = useApiContext()
  return useQuery({
    queryKey: ["peek-view", recordType, recordId],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchPeekViewData(context, recordType, recordId)
    },
    enabled: enabled,
  })
}
